export default __webpack_public_path__ + "static/media/about-thumb-2-challenge.a9962ff6.webp";